var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import Add from '@mui/icons-material/Add';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import OpenInNew from '@mui/icons-material/OpenInNew';
import NotifyButton from '../NotifyButton';
import CustomLoader from '../CommonComponents/CustomLoader';
import { useNurseryContext } from '../../contexts/NurseryContext';
var classes = {
    loaderRoot: function (theme) { return ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }); },
    select: {
        padding: 0,
        boxShadow: 'none',
        border: '1px solid #d8d8d8',
        '& ul': {
            padding: 0,
            backgroundColor: '#fff',
        },
    },
    menuItem: {
        color: '#5B6A74',
        padding: '15px 0 0',
        cursor: 'pointer',
        '& .item_wrapper': {
            borderBottom: '1px solid #d3d3d3',
            margin: '0 15px',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            width: '100%',
            paddingBottom: '15px',
        },
        '& p': {
            marginBottom: 0,
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '19px',
        },
        '& span': {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        '& .shopify_more_options': {
            display: 'flex',
            alignItems: 'center',
            padding: '0 12px 15px',
        },
    },
    noBorder: {
        border: 'none',
    },
    noMargin: {
        margin: 0,
    },
    hide: {
        display: 'none',
    },
};
var ShopifyBuy = function (_a) {
    var setOpenOptions = _a.setOpenOptions, _b = _a.isAvailable, isAvailable = _b === void 0 ? false : _b, _c = _a.notForSale, notForSale = _c === void 0 ? function () { } : _c, _d = _a.mainTitle, mainTitle = _d === void 0 ? '' : _d, onAddToShopifyCart = _a.onAddToShopifyCart, _e = _a.plant, variants = _e.variants, djangoPk = _e.django_pk, affiliatedLinks = _e.affiliated_links, nurseries = _e.nurseries;
    var _f = useNurseryContext(), isNursery = _f.isNursery, nurseryName = _f.nurseryName, nurserySlug = _f.nurserySlug;
    var _g = useState([]), shopifyProduct = _g[0], setShopifyProduct = _g[1];
    var _h = useState(affiliatedLinks), filteredLinks = _h[0], setFilteredLinks = _h[1];
    var _j = useState('none'), selectedVariant = _j[0], setSelectedVariant = _j[1];
    var _k = useState(false), addingToCart = _k[0], setAddingToCart = _k[1];
    var _l = useState(false), openSelect = _l[0], setOpenSelect = _l[1];
    var _m = useState(false), isAffiliatedLink = _m[0], setIsAffiliatedLink = _m[1];
    var availableOptions = (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) + (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length);
    var getFilteredAffiliatedLinks = function () {
        var filteredItems = affiliatedLinks;
        if (isNursery) {
            filteredItems = affiliatedLinks.filter(function (item) { return item.nursery.name === nurseryName; });
        }
        setFilteredLinks(filteredItems);
    };
    var getShopifyProductDetails = function () {
        var product = variants.filter(function (variant) { return variant.available; });
        if (isNursery && !isAvailable) {
            product = product
                .filter(function (variant) { return variant.fulfillment_service === nurserySlug; });
        }
        setShopifyProduct(product);
        if ((affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0) {
            getFilteredAffiliatedLinks();
        }
    };
    var getSaleUrl = function () {
        var item;
        if (isAffiliatedLink) {
            item = affiliatedLinks.find(function (link) { return link.id === selectedVariant; });
        }
        if (item) {
            return item.sale_url;
        }
        return '';
    };
    var handleAddToCart = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!(selectedVariant === 'none' && !openSelect)) return [3 /*break*/, 1];
                    setOpenSelect(true);
                    return [3 /*break*/, 3];
                case 1:
                    setAddingToCart(true);
                    return [4 /*yield*/, onAddToShopifyCart({ id: selectedVariant }, 1, djangoPk)];
                case 2:
                    _a.sent();
                    setAddingToCart(false);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (event) {
        var id = event.target.value;
        var mergeArray = __spreadArray(__spreadArray([], shopifyProduct, true), filteredLinks, true);
        mergeArray.forEach(function (item) {
            if (item.id === id) {
                setSelectedVariant(item.id);
            }
        });
    };
    var closeSelect = function () {
        setOpenSelect(false);
    };
    useEffect(function () {
        if ((shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) === 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) === 0) {
            if (notForSale) {
                try {
                    notForSale();
                }
                catch (error) {
                    Sentry.captureException(error);
                }
            }
        }
    }, [shopifyProduct, filteredLinks]);
    useEffect(function () {
        getShopifyProductDetails();
    }, [variants]);
    useEffect(function () {
        var item = shopifyProduct.find(function (product) { return product.id === selectedVariant; });
        setIsAffiliatedLink(!item && selectedVariant !== 'none');
    }, [selectedVariant]);
    return (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) === 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) === 0 ? (React.createElement("div", { className: "notify_container" },
        React.createElement(NotifyButton, { showTitle: false, djangoPk: djangoPk, plantName: mainTitle }),
        (nurseries === null || nurseries === void 0 ? void 0 : nurseries.length) > 0 && (React.createElement(Box, { sx: [classes.menuItem, classes.noBorder, classes.noMargin] },
            React.createElement("div", { onClick: function () { return setOpenOptions(true); }, role: "button", className: "shopify_more_options" },
                React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                React.createElement("p", null, "More Options")))))) : (React.createElement("div", { className: "shopify_btn" },
        React.createElement(Select, { open: openSelect, onClick: function () {
                if (!openSelect)
                    setOpenSelect(true);
            }, onClose: closeSelect, onBlur: closeSelect, defaultValue: "none", id: "menu", MenuProps: {
                sx: { paper: classes.select },
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
                transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
            }, onChange: handleChange, className: "variant_dd_wrapper", inputProps: { 'aria-label': 'Without label' }, value: selectedVariant },
            React.createElement(MenuItem, { sx: [classes.menuItem, classes.hide], value: "none" },
                React.createElement("p", { className: "plant_info" }, "Select a size"),
                React.createElement("span", { className: "select_shipping_info" },
                    availableOptions,
                    ' ',
                    "option",
                    availableOptions > 1 ? 's' : '',
                    ' ',
                    "available")),
            (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 && (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.map(function (item) {
                var _a;
                return (React.createElement(MenuItem, { sx: classes.menuItem, key: item.id, value: item.id },
                    React.createElement("div", { className: "item_wrapper" },
                        React.createElement("p", { className: "plant_info" },
                            item.title,
                            ' ',
                            "| $",
                            item.price),
                        React.createElement("span", { className: "select_shipping_info" }, (_a = item === null || item === void 0 ? void 0 : item.nursery) === null || _a === void 0 ? void 0 : _a.shipping_info))));
            })),
            (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 && filteredLinks.map(function (link) {
                var _a, _b;
                return (React.createElement(MenuItem, { sx: classes.menuItem, key: link.id, value: link.id },
                    React.createElement("div", { className: "item_wrapper" },
                        link.size || link.price ? (React.createElement("p", { className: "plant_info" },
                            link.size,
                            ' ',
                            "| $",
                            link.price)) : React.createElement("p", { className: "plant_info" }, (_a = link.nursery) === null || _a === void 0 ? void 0 : _a.name),
                        React.createElement("span", { className: "select_shipping_info" }, (_b = link === null || link === void 0 ? void 0 : link.nursery) === null || _b === void 0 ? void 0 : _b.shipping_info))));
            }),
            React.createElement(MenuItem, { onClick: function () { return setOpenOptions(true); }, sx: [classes.menuItem, classes.noBorder], value: "more-options" },
                React.createElement("div", { role: "button", className: "shopify_more_options" },
                    React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                    React.createElement("p", null, "More Options")))),
        isAffiliatedLink ? (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: getSaleUrl() },
            React.createElement("button", { type: "button", className: "btn primary" },
                React.createElement(OpenInNew, { sx: { padding: 0, marginRight: 2 } }),
                "Buy from nursery"))) : (React.createElement("button", { type: "button", className: "btn primary", id: "addcart_btn", onClick: handleAddToCart, disabled: addingToCart },
            React.createElement("img", { className: "add_to_cart", src: "".concat(process.env.STATIC_PATH, "/img/add-to-cart.png"), alt: "Add to cart" }),
            addingToCart ? (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })) : 'Add to Cart'))));
};
export default ShopifyBuy;
